import React from 'react';

import ResourceEmptyState from './ResourceEmptyState.react';
import GetStartedWithAlbert from './GetStartedWithAlbert.react';

interface Props {
  title: string;
  body: string;
}

const EmptyState = ({title, body}: Props) => {
  return (
    <div className='flex'>
      <ResourceEmptyState title={title} body={body} />
      <GetStartedWithAlbert />
    </div>
  );
};

export default EmptyState;
